export default "__VITE_ASSET__f881d9fa__"